/**
 * Selección de API Weight Loss por carril (regular vs insurance).
 * Criterio UI: `$route.meta.programContext` === 'insurance' | 'normal'.
 */
import wlPatientsApi, { wlPatientsInsuranceApi } from './patients'
import wlVisitsApi, { wlVisitsInsuranceApi } from './visits'
import wlAppointmentsApi, { wlAppointmentsInsuranceApi } from './appointments'
import wlReportsApi, { wlReportsInsuranceApi } from './reports'

export function isInsuranceLane(programContext) {
  return programContext === 'insurance'
}

export function getWlPatientsApi(programContext) {
  return isInsuranceLane(programContext) ? wlPatientsInsuranceApi : wlPatientsApi
}

export function getWlVisitsApi(programContext) {
  return isInsuranceLane(programContext) ? wlVisitsInsuranceApi : wlVisitsApi
}

export function getWlAppointmentsApi(programContext) {
  return isInsuranceLane(programContext) ? wlAppointmentsInsuranceApi : wlAppointmentsApi
}

export function getWlReportsApi(programContext) {
  return isInsuranceLane(programContext) ? wlReportsInsuranceApi : wlReportsApi
}

/** has_insurance viene como string "true" (no booleano). Acepta user o patient con .user */
export function userHasInsurance(entity) {
  if (!entity) return false
  const v = entity.has_insurance != null ? entity.has_insurance : entity.user && entity.user.has_insurance
  return v === true || v === 1 || String(v).toLowerCase() === 'true'
}
